import classNames from 'classnames';
import React from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { getColor } from '@utils';
import { AND_DELIMITER, OR_DELIMITER } from '@utils/constants';

import styles from './index.less';
import { defaultProps } from './propTypes';

export default class CombinationFilter extends React.PureComponent {
  onSelect = () => {
    const { selectCombinationFilterActionHandler, index } = this.props;
    selectCombinationFilterActionHandler(index);
  };

  onDelete = (e) => {
    e.stopPropagation();
    const { deleteActionHandler, index } = this.props;
    deleteActionHandler(index);
  };

  /* eslint-disable react/no-array-index-key */
  renderRules = () => {
    const { name } = this.props;
    const rules = name.split(AND_DELIMITER).map((andRule, idx1) => {
      const orRules = andRule.split(OR_DELIMITER).map((orRule, idx2) => {
        const result =
          idx2 === 0 ? (
            <span key={`or-rule-${idx2}`}>{orRule}</span>
          ) : (
            <React.Fragment key={`or-rule-${idx2}`}>
              <wbr />
              <span className={styles.or}>OR</span>
              <span>{orRule}</span>
            </React.Fragment>
          );
        return result;
      });
      const result =
        idx1 === 0 ? (
          <span key={`and-rule-${idx1}`}>{orRules}</span>
        ) : (
          <React.Fragment key={`and-rule-${idx1}`}>
            <wbr />
            <span className={styles.and}>AND</span>
            <span>{orRules}</span>
          </React.Fragment>
        );
      return result;
    });
    return rules;
  };
  /* eslint-enable react/no-array-index-key */

  render() {
    const { name, showMetric, metric, selectable, selectableState, enableDeleteIcon, index } =
      this.props;
    const color = getColor(index, name);
    const classes = classNames(styles.combinationFilter, styles.filterBar, {
      [styles.selected]: selectable && selectableState,
    });
    return (
      <>
        <div
          id={`filterbar-select-${name}`.toLowerCase()}
          role="button"
          tabIndex={0}
          className={classes}
          onClick={this.onSelect}
        >
          {showMetric && (
            <span className={styles.metricName}>{'short' in metric ? metric.short : ''}</span>
          )}
          <span className={styles.ribbon} style={{ backgroundColor: color }} />
          <span>{this.renderRules()}</span>

          {enableDeleteIcon && (
            <button
              id={`filterbar-delete-${name}`.toLowerCase()}
              type="button"
              className={styles.deleteBtn}
              onClick={this.onDelete}
              title="Delete"
            >
              <CloseOutlined />
            </button>
          )}
        </div>
      </>
    );
  }
}

CombinationFilter.defaultProps = defaultProps;
